import { useCallback, useEffect, useRef, useState } from "react";
import { getMemberTier, updateMemberTier } from "../../services/membersAdminService";
import { MemberTierModel } from "./models/MemberTierModel";

export const useMemberTier = (userId?: number) => {
    const isMoutedRef = useRef(true);
    const [loading, setLoading] = useState(false);
    const [memberTier, setMemberTier] = useState<MemberTierModel | null>(null);

    useEffect(() => {
        isMoutedRef.current = true;
        return () => {
            isMoutedRef.current = false;
        }
    });

    const load = useCallback(async () => {
        if(loading || !userId)
            return;
        try {
            setLoading(true);
            const _data = await getMemberTier(userId);
            if(!isMoutedRef.current)
                return;
            if(_data)
                setMemberTier(_data);
        }
        finally {
            if(!isMoutedRef.current)
                return;
            setLoading(false);
        }
    }, [userId]);
    
    useEffect(() => {
        load();
    }, [load]);
    
    const set = async (memberTierId: number | null) => {
        if(loading || !userId)
            return;
        setLoading(true);
        try {
            await updateMemberTier(userId, memberTierId);
            load();
        }
        catch { 
            if(!isMoutedRef.current)
                return;
            setLoading(false);
        }
    };

    return { loading, memberTier, updateMemberTier: set, reloadMemberTier: load };
}